
import { defineComponent } from "vue";
import MindGamesHeader from "@/components/MindGamesHeader.vue";

export default defineComponent({
  name: "SiteWrapper",

  computed: {
    isHome() {
      return this.$route.name === "Home";
    },
  },

  components: {
    MindGamesHeader,
  },
});
